import { render, staticRenderFns } from "./WebhooksSettings.vue?vue&type=template&id=313cd3fc&scoped=true&"
import script from "./WebhooksSettings.vue?vue&type=script&lang=js&"
export * from "./WebhooksSettings.vue?vue&type=script&lang=js&"
import style0 from "./WebhooksSettings.vue?vue&type=style&index=0&id=313cd3fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313cd3fc",
  null
  
)

export default component.exports